import type { Room } from '@/features/veluvit/types/api.types'

export function resolveChatMode(
  selected: string | undefined,
  room: Room | null | undefined
): string {
  if (selected?.trim()) return selected
  if (typeof room?.mode === 'string' && room.mode.trim()) return room.mode
  if (typeof room?.settings?.mode === 'string' && room.settings.mode.trim())
    return room.settings.mode
  return 'daily'
}
